import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HeaderImage from '@/components/HeaderImage';
import DecorativeDivider from '@/pages/contact/components/DecorativeDivider';

type LegalSection = {
  heading: string;
  paragraphs: string[];
};

type LegalContent = {
  title: string;
  updatedAt: string;
  sections: LegalSection[];
};

type LegalPageProps = {
  content: LegalContent;
};

export default function LegalPage({ content }: LegalPageProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <HeaderImage />

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <h1 className="font-heading font-bold text-4xl md:text-5xl text-foreground-950 leading-relaxed tracking-[0.15em] mb-8 text-center">
          {content.title}
        </h1>

        <DecorativeDivider />

        <p className="text-center font-body text-xs md:text-sm text-foreground-500 tracking-wide mb-10">
          {content.updatedAt}
        </p>

        <div className="space-y-8">
          {content.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 tracking-wide mb-3">
                {section.heading}
              </h2>
              {section.paragraphs.map((paragraph) => (
                <p
                  key={paragraph}
                  className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-3"
                >
                  {paragraph}
                </p>
              ))}
            </section>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}